/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Sample_CtaInputs */

const ja_playdata_sample_cta = /** @type {(inputs: Playdata_Sample_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンプルレポートを見る`)
};

const en_playdata_sample_cta = /** @type {(inputs: Playdata_Sample_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get the Free Sample Report`)
};

/**
* | output |
* | --- |
* | "Get the Free Sample Report" |
*
* @param {Playdata_Sample_CtaInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_sample_cta = /** @type {((inputs?: Playdata_Sample_CtaInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Sample_CtaInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_sample_cta(inputs)
	return en_playdata_sample_cta(inputs)
});